import {useEffect, useState} from 'react';

import {getCreateAiReviewUsageCount} from 'src/openapi/apis/ChangeRequestAiUsageControllerApi';
import {useAppDispatch} from 'src/store';

import {Icons} from '@pb/kit-component-icon';
import {Status, usePushNotification} from '@pb/kit-component-push-notification';

export const useCreateAiReviewUsageCount = (
    changeRequestId: number | undefined,
    shown: boolean,
): number => {
    const dispatch = useAppDispatch();
    const {onCreateNote} = usePushNotification();
    const [createAiReviewUsageCount, setCreateAiReviewUsageCount] = useState<number>(0);

    useEffect(() => {
        if (changeRequestId && shown) {
            const fetchData = async () => {
                const response = await dispatch(getCreateAiReviewUsageCount({changeRequestId}));

                if (response.payload.success) {
                    setCreateAiReviewUsageCount(response.payload.data ?? 0);
                }

                if (response.payload.error) {
                    onCreateNote({
                        id: 'getCreateAiReviewUsageCountError',
                        status: Status.ERROR,
                        message: response.payload.data?.message,
                        buttonProps: {iconProps: {type: Icons.CLOSE}},
                        autoHideTimeout: 10000,
                    });
                }
            };
            fetchData();
        }
    }, [changeRequestId, dispatch, onCreateNote, shown]);

    return createAiReviewUsageCount;
};
